
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
import CrossIconNew from "@/components/icons/CrossIconNew.vue";
import TableView from "@/components/v2/table/NewTable.vue";
import GET_TIMESHEET_ACTIVITY from "@/apollo/timesheet/GetTimesheetActivity.gql";
import FileFilled from "@/components/icons/FileFilled.vue";
import moment from "moment";
import RejectionModal from "./RejectionModal.vue";
import NoteModal from "./NoteModal.vue";
import UPDATE_SHEET from "@/apollo/timesheet/UpdateTimesheet.gql";
import UPDATE_PROJECT_ACTIVITY_TIMES from "@/apollo/projectActivities/UpdateProjectActivitiesTime.gql";
import { NOTIFICATION } from "@/entities/Events";
import { MessageStatus, MessageDuration } from "@/data/notificationsMessages";
import UiButton from "@/components/button/ui-button.vue";
import { STATUS, VALUE_TO_STATUS, PROJECT_ACTIVITY_TIME_VALUE_TO_STATUS } from '@/entities/TimesheetStatus'
import { msToHMS } from '@/utils/convertSecondsToReadable'

@Component({
  components: {
    ModalFullScreen,
    CrossIconNew,
    TableView,
    FileFilled,
    RejectionModal,
    NoteModal,
    UiButton,
  },
  apollo: {
    timesheet: {
      query: GET_TIMESHEET_ACTIVITY,
      variables() {
        return {
          sheetId: this.$route.query.sid,
        };
      },
      update(data: any) {
        return data.timesheet_by_pk;
      },
      skip() {
        if (this.$route.query.sid) {
          return false;
        }
        return true;
      },
    },
  },
})
export default class InvoiceDashboard extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isManager?: boolean;
  showRejectModal = false;
  showNoteModal = false;
  STATUS = VALUE_TO_STATUS
  note = null;
  columns = [
    {
      label: "Visit",
      field: "project_activity.start_date",
    },
    {
      label:"Client",
      field: "project_activity.project.client_name",
    },
    { label: "Hours Submitted", field: "hours" },
    // { label: "Rate", field: "rate" },
    { label: "Date", field: "created_at" },
    { label: "Status", field: "status" },
    { label: "Notes", field: "note" },
  ];
  timesheet: any = {};


  handleShowNote(message) {
    this.showNoteModal = true;
    this.note = message;
  }
  formatDate(date: string) {
    return moment(date).format("DD MMM, YYYY");
  }

  get loading() {
    return this.$apollo.queries.timesheet.loading;
  }

  handleCloseRejectModal() {
    this.showRejectModal = false;
  }
  handleProjectRoute(row) {
    this.$emit('projectClick', row);
  }
  handleOpenRejectModal() {
    this.showRejectModal = true;
  }
  async handleApproveRejectTimesheetPorjectActivitiesTime(status: string) {
    return await this.$apollo
      .mutate({
        mutation: UPDATE_PROJECT_ACTIVITY_TIMES,
        variables: {
          where: { timesheet_id: { _eq: this.$route.query.sid } },
          set: {
            status: status
          },
        },
      }).catch(e => console.log('error'))
  }
  async handleApproved(value) {
   
    return await this.$apollo
      .mutate({
        mutation: UPDATE_SHEET,
        variables: {
          set: {
            status: "APPROVED",
            is_new: false,
          },
          id: this.$route.query.sid,
        },
      })
      .then(async () => {
        await this.handleApproveRejectTimesheetPorjectActivitiesTime("APPROVED")
        this.$emit("refetch-timesheet");
        this.$eventBus.emit(NOTIFICATION, {
          status: MessageStatus.SUCCESS,
          title: `Successfully approved ${this.timesheet?.user?.given_name || ""}
              ${this.timesheet?.user?.family_name || ""} hours`,
          duration: MessageDuration.MEDIUM,
        });
        this.$emit("close");
      }).catch(e => console.log('error'));
  }

  async handleRejct(value) {
    const isnoteExist = (value.note || '').trim()
    if (value.reason === 'Other' && !isnoteExist) {
      this.$eventBus.emit(NOTIFICATION, {
        status: MessageStatus.INFO,
        title: "Please Provide a Reason.",
        duration: MessageDuration.MEDIUM,
      });
      return;
    }
    await this.$apollo
      .mutate({
        mutation: UPDATE_PROJECT_ACTIVITY_TIMES,
        variables: {
          where: { timesheet_id: { _eq: this.$route.query.sid } },
          set: {
            status: "REJECTED"
          },
        },
      }).catch(e => console.log('error'))
    return await this.$apollo
      .mutate({
        mutation: UPDATE_SHEET,
        variables: {
          set: {
            status: "REJECTED",
            // note: this.note,
            is_new: false,
            reject_reason: value.note || value.reason,
          },
          id: this.$route.query.sid,
        },
      })
      .then(async () => {
        await this.handleApproveRejectTimesheetPorjectActivitiesTime("REJECTED")

        this.$emit("refetch-timesheet");
        this.$eventBus.emit(NOTIFICATION, {
          status: MessageStatus.SUCCESS,
          title: "Successfully rejected hours",
          duration: MessageDuration.MEDIUM,
          message: `${this.timesheet?.user?.given_name || ""}
              ${this.timesheet?.user?.family_name || ""} will get notified of rejected hours.`,
        });
        this.$emit("close");
      });
  }
  convertSecondsToHoursMinutesSeconds(seconds) {
    if (typeof seconds !== "number" || isNaN(seconds) || seconds < 0) {
      return "0 s";
    }
    const time = msToHMS({ duration: seconds * 1000 });

    if (time?.time)
      return time.time
    const hours = Math.floor(seconds / 3600);
    const remainingMinutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    let result = "";
    if (hours > 0) {
      result += `${hours > 10 ? hours : `0${hours}`}`;
    }
    if (remainingMinutes > 0) {
      result += `:${remainingMinutes > 10 ? remainingMinutes : `0${remainingMinutes}`
        }`;
    }
    if (remainingSeconds > 0) {
      result += `:${remainingSeconds > 10 ? remainingSeconds : `0${remainingSeconds}`
        }`;
    }
    if (result === "") {
      result = "00:00:00";
    }

    return result;
  }
  totalTimeTrack(time) {
    const total_seconds = time;
    const hours = Math.floor(total_seconds / 3600);
    const minutes = Math.floor((total_seconds % 3600) / 60);
    const seconds = total_seconds % 60;
    return `${hours}:${minutes.toString().padStart(2, "0")}`;
    // return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
    //   .toString()
    //   .padStart(2, "0")}`;
  }
  status(value) {
    return STATUS[value];
  }
  statusClasses(value) {
    return PROJECT_ACTIVITY_TIME_VALUE_TO_STATUS[value];
  }
  formatCurrency(value) {
    if (!value)
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "CAD",
      }).format(0);

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "CAD",
    }).format(value);
  }
  gettimeRangeFormat(start, end) {
    const startDate = start ? moment(start).format("DD MMM, YYYY") : "";
    const endDate = end ? moment(end).format("DD MMM, YYYY") : "";
    return `${startDate} -
      ${endDate}`;
  }
}
